module.exports = __webpack_public_path__ + "media/images/img_tokuhara-7ae66efdad15ba2216884f1e0fc5160f.jpg";